/**
 * DecisionNode - Conditional branch node (card style)
 */
import { useContext } from 'react';
import { Handle, Position } from 'reactflow';
import { IonIcon } from '@ionic/react';
import { gitBranchOutline } from 'ionicons/icons';
import { WorkflowActionsContext } from '../contexts/WorkflowActionsContext';
import './DecisionNode.css';

export const DecisionNode = ({ data, isConnectable }) => {
  const { label = 'Condition', onClick, nodeId, canDelete = false } = data || {};
  const actions = useContext(WorkflowActionsContext);
  
  const handleContextMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    actions?.onNodeContextMenu(nodeId, { x: e.clientX, y: e.clientY });
  };
  
  const handles = (
    <>
      <Handle type="target" position={Position.Top} id="top" isConnectable={isConnectable} className="gwe-decision-node__handle" />
      <Handle type="target" position={Position.Left} id="target-left" isConnectable={isConnectable} className="gwe-decision-node__handle gwe-decision-node__handle--side" />
      <Handle type="target" position={Position.Right} id="target-right" isConnectable={isConnectable} className="gwe-decision-node__handle gwe-decision-node__handle--side" />
      <Handle type="source" position={Position.Top} id="source-top" isConnectable={false} className="gwe-decision-node__handle" />
      <Handle type="source" position={Position.Bottom} id="bottom" isConnectable={false} className="gwe-decision-node__handle" />
      <Handle type="source" position={Position.Left} id="left" isConnectable={false} className="gwe-decision-node__handle gwe-decision-node__handle--side" />
      <Handle type="source" position={Position.Right} id="right" isConnectable={false} className="gwe-decision-node__handle gwe-decision-node__handle--side" />
    </>
  );
  
  return (
    <div className="gwe-decision-node" onClick={(e) => onClick?.(e)} onContextMenu={handleContextMenu}>
      {handles}
      
      {canDelete && (
        <button
          className="gwe-decision-node__remove-btn"
          onClick={(e) => { e.stopPropagation(); actions?.onRequestRemoveNode(nodeId); }}
          title="Delete branch"
        >
          ×
        </button>
      )}
      
      <div className="gwe-decision-node__card" title="Click to edit conditional logic">
        <div className="gwe-decision-node__icon-box">
          <IonIcon icon={gitBranchOutline} className="gwe-decision-node__icon" />
        </div>
        <div className="gwe-decision-node__label">{label}</div>
      </div>
    </div>
  );
};
